import React from "react";
import "./bread-crumb-file.css";

function BreadcrumbFile({ path, onClick }) {
    return (
        <div className="breadcrumb-file">
            {path.map((folder, index) => (
                <React.Fragment key={folder.alias}>
                    <span className="breadcrumb-item" onClick={() => onClick(folder)}>
                        {folder.name}
                    </span>
                    {index < path.length - 1 && 
                        <span className="breadcrumb-item-icon">
                            <em className="la la-angle-right"></em>
                        </span> 
                    }
                    
                </React.Fragment>
            ))}
        </div>
    );
}

export default BreadcrumbFile;
